module.exports = __webpack_public_path__ + "img/图片18.28d59e98.png";